<template>
  <section>
    <header class="mb-2 flex items-center justify-between">
      <h3 class="text-lg font-extrabold">
        {{ formattedDate }}
      </h3>

      <client-only>
        <template #fallback>
          <app-button class="min-w-[100px]" disabled size="small" tag="span" />
        </template>

        <course-page-enrolment-registration-request-cta
          v-if="
            hasOrganizationMembership && !session.is_sold_out && session.public
          "
          color="dark"
          :course="course"
          :session="session"
          size="small"
          variant="outlined"
        />

        <app-button
          v-else-if="currentUserIsAlreadyRegistered"
          disabled
          icon="ph:check"
          size="small"
        >
          {{ $t("course.page.enroled_label_short") }}
        </app-button>

        <app-button
          v-else-if="session.is_sold_out || !session.public"
          disabled
          icon="ph:circle-wavy-warning"
          size="small"
        >
          {{ $t("course.session.sold_out_label") }}
        </app-button>

        <course-page-enrolment-buy-cta
          v-else
          color="dark"
          :label="
            $t('course.page.next_session_enrolment.primary_cta_label_short')
          "
          :session="session"
          size="small"
          variant="outlined"
        />
      </client-only>
    </header>

    <course-page-session-chip-info :course="course" :session="session" />
  </section>
</template>

<script lang="ts" setup>
import type { CoursePageView } from "~/business-areas/course/course.model";
import type { CourseSessionView } from "~/business-areas/course-session/course-session.model";
import CoursePageSessionChipInfo from "~/pages/courses/[slug]/_includes/components/course-page-session-chip-info.vue";
import CoursePageEnrolmentBuyCta from "~/pages/courses/[slug]/_includes/components/enrolment/course-page-enrolment-buy-cta.vue";
import CoursePageEnrolmentRegistrationRequestCta from "~/pages/courses/[slug]/_includes/components/enrolment/course-page-enrolment-registration-request-cta.vue";

const properties = defineProps<{
  course: CoursePageView;
  session: CourseSessionView;
}>();

const { formattedDate } = useCourseSessionInfo(properties.session);

const { isRegisteredToCourseSession } = useLearnerProfile();
const currentUserIsAlreadyRegistered = computed(() =>
  isRegisteredToCourseSession(properties.session.id),
);

const { hasOrganizationMembership } = useOrganizationMemberProfile();
</script>
